




export function getBlogRow(blog: any, index: number)
{
    return `<div class="blogRow">
        <div class="container">
            <div class="row">
                <div class="col-md-12 paddingZero">
                    <div class="blogBox">
                        <div class="blogImg">
                            <div class="blogImgInside">
                                <img src="${blog.custom_s_article_summary_Image_url}" alt="${blog.custom_t_content_summary_Image_url_alt}">
                            </div>
                        </div>
                        <div class="blogTxt">
                            <div class="blogTxtInside">
                                <h2>${blog.custom_s_heading}</h2>
                                <p>
                                    <span class="blue-bold-regular-text">${blog.custom_t_content_summary_Desc} […] </span>
                                </p>
                                <a href="${blog.custom_s_local_url}" data-index="${index}" class="linkText articleLink">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
}
